import React from "react";
import Typography from "../Typography";
import ErrorMsg from "../ErrorMsg";

const Input = React.forwardRef(
  (
    {
      type = "text",
      placeholder = "",
      value,
      onChange,
      label = "",
      error = "",
      disabled = false,
      className = "",
      noWrapper = false,
      rows = 1,
      ...props
    },
    ref
  ) => {
    const inputElement =
      type === "textarea" ? (
        <textarea
          ref={ref}
          rows={rows}
          placeholder={placeholder}
          disabled={disabled}
          className={`
          w-full px-2 border rounded-lg
          focus:outline-none focus:ring-2 focus:ring-primary
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${error ? "border-red-500" : "border-gray-300"}
          ${className}
        `}
          {...props}
          value={value}
          onChange={onChange}
        />
      ) : (
        <input
          ref={ref} // ✅ IMPORTANT
          type={type}
          placeholder={placeholder}
          disabled={disabled}
          className={`
          w-full px-2 border rounded-lg
          focus:outline-none focus:ring-2 focus:ring-primary
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${error ? "border-red-500" : "border-gray-300"}
          ${className}
        `}
          {...props}
          value={value}
          onChange={onChange}
        />
      );

    if (noWrapper) {
      return inputElement;
    }

    return (
      <div className="w-full">
        {label && (
          <Typography
            variant="text2"
            component="label"
            className="block font-medium text-gray-700 mb-1"
          >
            {label}
          </Typography>
        )}
        {inputElement}
        {error && <ErrorMsg message={error} className="mt-1" />}
      </div>
    );
  }
);

export default Input;
